const MuiCardHeader = {
  styleOverrides: {
    content: {
      paddingBottom: '4px',
    },
  },
};

export default MuiCardHeader;
